var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6c0-1.6547 1.3453-3 3-3h12c1.6547 0 3 1.3453 3 3v12c0 1.6547-1.3453 3-3 3H6c-1.6547 0-3-1.3453-3-3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stop.fb5897813affb2db1076fcdf8e87f2bd.svg";